import { useState } from "react";

export function useToggle(initialValue: boolean): [boolean, () => void] {
	const [toggle, setToggle] = useState(initialValue);

	return [toggle, () => setToggle(!toggle)];
}
